var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsHorizontal = function SvgDotsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.09 7.322c.834 0 1.517-.683 1.517-1.518s-.683-1.518-1.518-1.518-1.518.683-1.518 1.518.683 1.518 1.518 1.518Zm0 1.518c-.836 0-1.519.683-1.519 1.518 0 .834.683 1.517 1.518 1.517s1.518-.683 1.518-1.517c0-.835-.683-1.518-1.518-1.518Zm0 4.553c-.836 0-1.519.683-1.519 1.518s.683 1.518 1.518 1.518 1.518-.683 1.518-1.518-.683-1.518-1.518-1.518Z",
    fill: "#73777A"
  })));
};
export default SvgDotsHorizontal;